import { useAutoRoutingUK } from '../../../hooks/useAutoRouting/useAutoRoutingUK';
import { useBrokerRedirect } from '../../../hooks/useBrokerRedirect';

type TProps = {
  children?: React.ReactNode;
};

const StepRouterUK = ({ children }: TProps) => {
  useBrokerRedirect();
  useAutoRoutingUK();

  return <>{children}</>;
};

export default StepRouterUK;
